import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'
import Select from 'react-select'
import '../../components/GeneralCss.css'

function AutoCompleteSelect(props) {
    const { label, name, options, ...rest } = props
    if(props.isMultipe === 'true'){
       
        return (
            <div className="formSingleElementAuto">
                <label className="formSingleElementLabel">{label}</label>
                <Field name={name} >
                    {
                        ({ form, field }) => {
                            const { setFieldValue } = form
                            const { value } = field
                            return <Select className="formSingleElementField" id={name} {...field} {...rest} name={name} options={options}
                                value={value} isMulti="true"
                            />
                        }
                    }
                </Field>
                <ErrorMessage name={name} component={TextError} />
            </div>
        )
    }else{
        return (
            <div className="formSingleElementAuto" >
                <label className="formSingleElementLabel">{label}</label>
                <Field name={name} >
                    {
                        ({ form, field }) => {
                            const { setFieldValue } = form
                            const { value } = field
                            return <Select className="formSingleElementField" id={name} {...field} {...rest} name={name} options={options} 
                                value={options ? options.find(option => option.value === value) : ''}
                            />
                        }
                    }
                </Field>
                <ErrorMessage name={name} component={TextError} />
            </div>
        )
    }
    
}

export default AutoCompleteSelect